export default "__VITE_ASSET__1Ex6LTDs__"